var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgRouteIcon(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 7V3.5m0 0L6.5 5M8 3.5L9.5 5M8 9v3.5m0 0L9.5 11M8 12.5L6.5 11M2.5 8H6m0 0L4.5 6.5M6 8L4.5 9.5M13.5 8H10m0 0l1.5 1.5M10 8l1.5-1.5",
    stroke: "#8C4FFF"
  })));
}
export default "data:image/svg+xml;base64,PHN2ZyB3aWR0aD0iMTYiIGhlaWdodD0iMTYiIHZpZXdCb3g9IjAgMCAxNiAxNiIgZmlsbD0ibm9uZSIKICAgIHhtbG5zPSJodHRwOi8vd3d3LnczLm9yZy8yMDAwL3N2ZyI+CiAgICA8cGF0aCBkPSJNOCA3VjMuNU04IDMuNUw2LjUgNU04IDMuNUw5LjUgNSIgc3Ryb2tlPSIjOEM0RkZGIi8+CiAgICA8cGF0aCBkPSJNOCA5TDggMTIuNU04IDEyLjVMOS41IDExTTggMTIuNUw2LjUgMTEiIHN0cm9rZT0iIzhDNEZGRiIvPgogICAgPHBhdGggZD0iTTIuNSA4TDYgOE02IDhMNC41IDYuNU02IDhMNC41IDkuNSIgc3Ryb2tlPSIjOEM0RkZGIi8+CiAgICA8cGF0aCBkPSJNMTMuNSA4TDEwIDhNMTAgOEwxMS41IDkuNU0xMCA4TDExLjUgNi41IiBzdHJva2U9IiM4QzRGRkYiLz4KPC9zdmc+Cg==";
export { SvgRouteIcon as ReactComponent };